const routes = {
  createSupplier: 'supplier',
  getSuppliers: 'supplier',
  getSupplierById: 'supplier/',
  updateSupplier: 'supplier/',
  deleteSupplier: 'supplier/',
};

export default routes